import { royalBlue50 } from "../colors.js";
export const abbreviateName = name => {
  const trimmedName = name?.trim() ?? "";
  if (trimmedName.length === 0) {
    return "";
  }
  const words = trimmedName.split(/\s+/);
  const firstLetter = words[0][0];
  if (!firstLetter) {
    return "";
  }
  if (words.length === 1) {
    return firstLetter.toUpperCase();
  }
  const secondLetter = words.at(-1)?.[0];
  if (secondLetter == null) {
    return firstLetter.toUpperCase();
  }
  return firstLetter.toUpperCase() + secondLetter.toUpperCase();
};
function getColourBasedOnName(name) {
  const trimmedName = name?.trim() ?? "";
  if (trimmedName.length === 0) {
    return royalBlue50;
  }

  // eslint-disable-next-line @typescript-eslint/no-misused-spread
  const stringUniqueHash = [...trimmedName].reduce((acc, char) => {
    const codePoint = char.codePointAt(0);
    if (codePoint == null) {
      return acc;
    }
    return codePoint + ((acc << 5) - acc);
  }, 0);
  return `hsl(${stringUniqueHash % 360}, 100%, 90%)`;
}
export function getCssColoursBasedOnName(name) {
  const color = getColourBasedOnName(name);
  return {
    backgroundColor: color,
    borderColor: color
  };
}
//# sourceMappingURL=name.js.map